<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
              
                <h1>{{ecmResourceStrings.ttlExecutionDetails}} {{partitiondescription}}</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer">
                <otif-button class="OTSecondary"  @click.native="back" id="backtoexec" :title="ecmResourceStrings.tipBackToExec" >{{ecmResourceStrings.lblBack}}</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col >
                <SettingsTable 
                    :rows="repotypes"
                    :columns="columns"
                    :customOptions="customOptions"
                    :columnlabel="columnlabel"
                    :actions="actions"
                    @sort="sort">
                    <template slot="table-header">
                        <h1 class="text-center OT-table-title"></h1>
                    </template>
                </SettingsTable>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import axios from 'axios';
import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmRepositoryTypes from '@/ecm/collections/ecmrepositorytypes.js';
import { showMessage} from '../../utils/commonECM.js';
import { sortOn } from '../../utils/commonECM.js';
import { getguivalue } from '../../utils/commonECM.js';
import Collection from '@/collections/basic.js';

export default {

    props: ['ecmrepositorytype', 'ecmrepositoryid', 'partitiondescription', 'partitionid', 'col','otherProp'],

    components: {
        SettingsTable
    },

    data() {
        return {
            ecmResourceStrings: require('../../utils/resourceECM.js'),   
            configs: [],
            sortDir:'asc',
            collectionconnections : [],
            loaded: false,
            customOptions: [],
            columnlabel:"Actions",
            columns: [
            {
                name: 'connection',
                label: 'Connection Description',
                sortable: true,
                editable:false,
                render(row) {
                    return row.ecmconnection;
                }
            },{
                name: 'operationtype',
                label: 'Operation Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.operationtype;
                }
            },{
                name: 'startdate',
                label: 'Start Date',
                sortable: true,
                editable:false,
                render(row) {
                    return row.startdate;
                }
            },{
                name: 'enddate',
                label: 'End Date',
                sortable: true,
                editable:false,
                render(row) {
                    return row.enddate;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.status;
                }
            },{
                name: 'number',
                label: 'Number Of Threads',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.numberthreads;
                }
            },{
                name: 'engine',
                label: 'Engine Name',
                sortable: true,
                editable:false,
                render(row) {
                    return row.enginename;
                }
            },{
                name: 'master',
                label: 'Is Master',
                sortable: true,
                editable:false,
                width:'10%',
                render(row) {
                    return row.isMaster;
                }
            }],
            actions: [{
                    name: 'details',
                    label: "Details",
                    callback: (row) => { this.showDetails(row); }
                },{
                    name: 'warnings',
                    label: "Warnings\\Errors",
                    callback: (row) => { this.showWarnings(row); }
                },{
                    name: 'history',
                    label: "History",
                    callback: (row) => { this.showHistory(row); }
                }],
        }
    },

    computed: {
        repotypes() {
            return this.configs;
        },
    },

    methods: {
        refresh() {
            this.loaded = true;
        },

        back()
        {
            if(this.ecmrepositorytype =="dbms_generic_v1")
            {
                this.$router.push('/reports/rdbmscrawlerexecutions');
            }
            else{
                this.$router.push('/reports/ecmcrawlerexecutions');
            }
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            if(colNumber == 0)
                that.configs.sort(sortOn('repositoryType', dir));
            else
                that.configs.sort(sortOn('description', dir));
        },

        showDetails(rowNumber)
        {
              
            const onepartition = this.configs[rowNumber];
            if(onepartition)
            {
                const oticlogid = onepartition.oticlogid;
                const ecmrepositorytype = this.ecmrepositorytype;
                const ecmrepositoryid = this.ecmrepositoryid;
                const partitiondescription = this.partitiondescription;
                const partitionid = this.partitionid;
                //const connectionid = onepartition.connectionID;
                const connectiondescr=onepartition.ecmconnection;
                const operationType = onepartition.operationtype;
           
                const data = encodeURIComponent(oticlogid) + "/" + encodeURIComponent(ecmrepositorytype) + "/" + encodeURIComponent(ecmrepositoryid) + "/" + encodeURIComponent(partitiondescription) + "/" + encodeURIComponent(partitionid)+ "/" + encodeURIComponent(this.col);
                if(this.ecmrepositorytype =="dbms_generic_v1")
                {
                    this.$router.push('/reports/rdbmscrawlerexecutions/rdbmsexecutiondetails/'+ data);
                }
                else{
                    this.$router.push('/reports/ecmcrawlerexecutions/executiondetails/'+ data);
                }
            }
        },

        showWarnings(rowNumber)
        {
            const onepartition = this.configs[rowNumber];
            if(onepartition)
            {
                const oticlogid = onepartition.oticlogid;
                const ecmrepositorytype = this.ecmrepositorytype;
                const ecmrepositoryid = this.ecmrepositoryid;
                const partitiondescription = this.partitiondescription;
                const partitionid = this.partitionid;
                //const connectionid = onepartition.connectionID;
                const connectiondescr=onepartition.ecmconnection;
                const operationType = onepartition.operationtype;
           
                const data = encodeURIComponent(oticlogid) + "/" + encodeURIComponent(ecmrepositorytype) + "/" + encodeURIComponent(ecmrepositoryid) + "/" + encodeURIComponent(partitiondescription) + "/" + encodeURIComponent(partitionid)+ "/" + encodeURIComponent(this.col);
                if(this.ecmrepositorytype =="dbms_generic_v1")
                {
                    this.$router.push('/reports/rdbmscrawlerexecutions/rdbmsexecutionwarnings/'+ data);
                }
                else{
                    this.$router.push('/reports/ecmcrawlerexecutions/executionwarnings/'+ data);
                }
            }
        },

        showHistory(rowNumber)
        {
            const onepartition = this.configs[rowNumber];
            if(onepartition)
            {
                const oticlogid = onepartition.oticlogid;
                const ecmrepositorytype = this.ecmrepositorytype;
                const ecmrepositoryid = this.ecmrepositoryid;
                const partitiondescription = this.partitiondescription;
                const partitionid = this.partitionid;
                //const connectionid = onepartition.connectionID;
                const connectiondescr=onepartition.ecmconnection;
                const operationType = onepartition.operationtype;
           
                const data = encodeURIComponent(oticlogid) + "/" + encodeURIComponent(ecmrepositorytype) + "/" + encodeURIComponent(ecmrepositoryid) + "/" + encodeURIComponent(partitiondescription) + "/" + encodeURIComponent(partitionid)+ "/" + encodeURIComponent(this.col);
                 if(this.ecmrepositorytype =="dbms_generic_v1")
                {
                    this.$router.push('/reports/rdbmscrawlerexecutions/rdbmsexecutionhistory/'+ data);
                }
                else{
                    this.$router.push('/reports/ecmcrawlerexecutions/executionhistory/'+ data);
                }
                
            }
        },

        getECMRepositoryStatus(ecmrepositoryid, partitionID) {
        const action = 'executionStatus?repositoryId=' +ecmrepositoryid + '&partitionId=' + partitionID;
        return axios.get('/mtm-gateway-api/v1/services/ecm/query/' + action, 
            {headers: {"Content-Type": "application/json; charset=UTF-8"}});
        },

        getconnectionname: function(id) {
            var that = this;
            var name='';
            for(var i = 0; i < that.collectionconnections.length; i++)
            {
                if(that.collectionconnections[i].id == id)
                {
                    name = that.collectionconnections[i].name;
                    
                    break;
                }
            }
            return name;
        },
    },

    mounted() {
            if(this.ecmrepositorytype =="dbms_generic_v1")
            {
                var breadcrumbs = [{
                name: 'reports',
                meta: { label: 'Reports' }
                },{
                    name: 'rdbms-executions',
                    meta: { label: 'Executions' }
                },{
                    name: 'rdbmspartitionexecutiondetails',
                    meta: { label: 'Execution Details' }
                }];

                this.$store.commit('breadcrumbs', breadcrumbs);
            }
            else
            {
                var breadcrumbs = [{
                    name: 'reports',
                    meta: { label: 'Reports' }
                },{
                    name: 'ecm-executions',
                    meta: { label: 'Executions' }
                },{
                    name: 'ecmpartitionexecutiondetails',
                    meta: { label: 'Execution Details' }
                }];

                this.$store.commit('breadcrumbs', breadcrumbs);
            }
        
    },

    async created() {
        var that = this;
        that.collconnection = that.col;
        that.configs=[];
        const connectstr = that.collconnection.split(',');
        const lennames = connectstr.length;
        that.collectionconnections = [];
        for(var t = 0; t < lennames; t++)
        {
            const onestring = connectstr[t];
            const clostr = onestring.split('~');
            that.collectionconnections.push({id:clostr[1], name:clostr[0]});
        }

        try
        {
            const res = await that.getECMRepositoryStatus(that.ecmrepositoryid, that.partitionid); 

            if(res && res.data && res.data.jobExecutionDetails)
            {
                const jobExecutionDetailslist = res.data.jobExecutionDetails;
                if(jobExecutionDetailslist !== undefined && jobExecutionDetailslist !== null)
                {
                    const len = jobExecutionDetailslist.length;
                    if(len!=0)
                    {
                        for(var k = len - 1; k > -1; k--)
                        {                                                                       
                            const crawleroperationdetails = jobExecutionDetailslist[k];
                            if(crawleroperationdetails)
                            {
                                const repositoryIdx  = crawleroperationdetails.repositoryId;
                                const partitionIdx  = crawleroperationdetails.partitionId;
                                const connectionIdx  = crawleroperationdetails.ecmConnectionId;
                                const connectionname = that.getconnectionname(connectionIdx);
                                const operationTypex  = crawleroperationdetails.operationType;
                                const opertypegui = getguivalue('operationtype', operationTypex);
                                const isRunningx  = crawleroperationdetails.isRunning;
                                var isRunning = "";
                                if(crawleroperationdetails.isRunning != '0')
                                { 
                                    isRunning= 'Running';
                                }
                                else
                                {
                                    isRunning = 'Finished';
                                }
                                const isMaster  = crawleroperationdetails.isMaster;
                                const isMastergui = getguivalue('isMaster', isMaster);
                                var startDate  = '';
                                if(crawleroperationdetails.startDate)
                                {
                                    startDate = crawleroperationdetails.startDate;
                                    const d = new Date(startDate);
                                    if(d == "Invalid Date")
                        	        {
                        	          	startDate = startDate.toLocaleString();
                        	        }
                        	        else
                        	        {
                        	        	startDate = d.toLocaleString(); 
                        	        }	
                                   // startDate = d.toLocaleString(); 
                                }
                                var endDate = '';
                                if(crawleroperationdetails.endDate)
                                {
                                    endDate  = crawleroperationdetails.endDate;
                                    const d = new Date(endDate);
                                    if(d == "Invalid Date")
                        	        {
                        	        	endDate = endDate.toLocaleString();
                        	        }
                        	        else
                        	        {
                        	        	endDate = d.toLocaleString(); 
                                    }	
                                    //endDate = d.toLocaleString(); 
                                }
                                var status = '-1';
                                if(crawleroperationdetails.status != undefined && crawleroperationdetails.status != null )
                                {
                                    status  = crawleroperationdetails.status;
                                }
                               else{
                                    if(isRunningx != 0)
                                        status = isRunningx;
                                }
                                const statusgui = getguivalue('infofusionexecutionstatus', status);
                                const numberThreads  = crawleroperationdetails.numberThreads;
                                const crawlerProcessId  = crawleroperationdetails.crawlerProcessId;
                                const oticEngineName  = crawleroperationdetails.oticEngineName;
                                var obj = {};
                                obj = {ecmconnection: connectionname, operationtype : opertypegui, startdate: startDate, enddate:endDate, status : statusgui,numberthreads:numberThreads,enginename:oticEngineName, isMaster:isMastergui, oticlogid:crawlerProcessId }
                                that.configs.push(obj);         
                            }
                        }
                    }
                }
            }
            that.loaded = true;
        }
        catch (res1)
        {
            this.$snotify.clear();
            if(res1.response && res1.response.data)
            {
                this.$snotify.error(res1.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        };
    }
}

</script>